import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

import style from './Article.style'

const ArticleStyled = styled.div(props => ({ ...style(props) }))

const Article = ({ content, md, contain }) => {
    return content ? (
        <ArticleStyled contain={contain}>
            {md ? (
                <article>
                    <ReactMarkdown source={content} escapeHtml={false} />
                </article>
            ) : (
                /* eslint-disable react/no-danger */
                <article dangerouslySetInnerHTML={{ __html: content }} />
            )}
        </ArticleStyled>
    ) : null
}

Article.propTypes = {
    content: PropTypes.string,
    md: PropTypes.bool,
    contain: PropTypes.bool
}

Article.defaultProps = {
    content: undefined,
    md: false,
    contain: false
}

export default withTheme(Article)
